import { InfoCircleFill } from "react-bootstrap-icons";

interface InfoBoxProps {
    children?: React.ReactNode;
    htmlContent?: string;
    className?: string;
    style?: React.CSSProperties;
}

export function InfoBox({ children, htmlContent, className = "", style }: InfoBoxProps) {
    const defaultStyle = { backgroundColor: 'var(--color-light)' };
    const combinedStyle = { ...defaultStyle, ...style };

    return (
        <div 
            className={`alert alert-purple my-3 d-flex align-items-center gap-2 ${className}`} 
            style={combinedStyle}
        >
            <InfoCircleFill className="fs-5 flex-shrink-0" />
            {htmlContent ? (
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            ) : (
                children
            )}
        </div>
    );
} 